import { SingleUser } from 'utils/api/models/users/singleUser';
import modelsResolver from 'utils/api/models/utils/modelsResolver';

export type AccountData = {
	accountId: string;
	accountName: string;
	documentId: string;
	documentType: types.organizations.documentType;
	email: string;
	contactNumber: string;
	region: string;
	city: string;
	way: string;
	house: string;
	apartment: string;
	landmark?: string;
	taxId?: string;
};

export type AccountDetails = {
	_managers: any;
	_admins: any;
	managers?: SingleUser[];
	admins?: SingleUser[];
	accountDetails: AccountData;
};

const model: types.models.InputModel = {
	_managers: ['response.getCorpAccountDetailsResponse.managers', []],
	_admins: ['response.getCorpAccountDetailsResponse.admins', []],
	accountDetails: 'response.getCorpAccountDetailsResponse.accountDetails',
	managers: (model: AccountDetails) => model._managers.map((manager: any) => modelsResolver(manager, 'singleUser')),
	admins: (model: AccountDetails) => model._admins.map((admin: any) => modelsResolver(admin, 'singleUser')),
};

export default model;
